import {
    FETCH_PROJECT_COMPARISON_START,
    FETCH_PROJECT_COMPARISON_SUCCESS,
    FETCH_PROJECT_COMPARISON_FAIL

} from "../../../constants";
import {
    FETCH_PROJECT_COMPARISON_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

// payload: { benchmarkFilters, listType, from, size, searchText }. The endpoint
// pages over leaders, so `from` > 0 is a "load more" and the reducer appends.
export const getProjectComparison = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_PROJECT_COMPARISON_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_PROJECT_COMPARISON_URL, {
                ...payload, ...getProjectIdAndOrgId(payload), currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_PROJECT_COMPARISON_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(true, res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_PROJECT_COMPARISON_FAIL, { ...err, ...payload }));
                cb && cb(false)
            });
    };
};
